// Available interface languages with their display label and flag.
export const LANGUAGES = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
];

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);

// The system default language chosen by the Gestore for this restaurant.
// It is persisted locally whenever we learn it (device state / unlock / login),
// so the language picker can show it first and the UI can present it initially.
export const DEFAULT_LANG_KEY = 'rmp_default_lang';

export const getDefaultLangCode = () => {
  try {
    const d = localStorage.getItem(DEFAULT_LANG_KEY);
    return LANGUAGE_CODES.includes(d) ? d : 'it';
  } catch (e) {
    return 'it';
  }
};

export const setDefaultLangCode = (code) => {
  if (!LANGUAGE_CODES.includes(code)) return;
  try { localStorage.setItem(DEFAULT_LANG_KEY, code); } catch (e) { /* ignore */ }
};

// Returns the language list with the given default language placed first.
export const orderedLanguages = (defaultCode) => {
  const d = LANGUAGE_CODES.includes(defaultCode) ? defaultCode : getDefaultLangCode();
  const first = LANGUAGES.find((l) => l.code === d);
  if (!first) return LANGUAGES;
  return [first, ...LANGUAGES.filter((l) => l.code !== d)];
};
